module.exports = __webpack_public_path__ + "static/media/brad_parry_portrait.3f76089b.PNG";